import {
	DocumentWorkflowInstanceSignatureStatus,
	InvestmentProgrammeDocumentDetailsRes,
} from '@dealstack/shared/lib/generated';

/**
 * After a signature is claimed on behalf, the backend generates the claimed
 * investor's document asynchronously; the signature leaves `CREATED` (it
 * becomes `PENDING_SIGNATURE`) once the file exists. This is the signal that
 * the claimed signer is ready to sign.
 */
export const isClaimedSignerGenerated = (
	payload: InvestmentProgrammeDocumentDetailsRes | undefined,
	signerId: string
): boolean => {
	const signer = payload?.groups
		.flatMap((group) => group.signers)
		.find((candidate) => candidate.id === signerId);
	return (
		!!signer &&
		signer.status != null &&
		signer.status !== DocumentWorkflowInstanceSignatureStatus.CREATED
	);
};
